import i18n from 'i18next'
import { FC } from 'react'
import { CustomList } from '../../../../components/Display/Lists'
import { BuildingInfoDisplay, buildingInfoOrder } from '../utils/dataHandling'

interface ApartmentInformationListProps {
  apartmentInformation: BuildingInfoDisplay
  t: i18n.TFunction
}

const ApartmentInformationList: FC<ApartmentInformationListProps> = ({
  apartmentInformation,
  t
}) => (
  <CustomList
    t={t}
    translationPath='apartment.list.information.'
    data={apartmentInformation}
    informationOrder={buildingInfoOrder}
  />
)

export default ApartmentInformationList
